import {createAsyncThunk, createSlice, isAnyOf} from '@reduxjs/toolkit';

import { connect } from 'utils/wssUtils';
import {handleError, startLoading} from 'utils/sliceUtils';
import {selectDemo} from "../enrollment/slice";
import {decryptParams, shortUrl } from "../enrollment/api";
import {fetchResults} from "./api";
import {uploadImageFromFile} from "../../utils/s3Utils";
import awsConfig from "../../config/awsConfig";
import {webSocket} from "rxjs/webSocket";


const initialState = {
  params         : { uuid: null },
  isLoading      : true,
  isInitiated    : false,
  shortUrl       : null,
  resultComplete : false,
  showResult     : false,
  results        : null,
};

const slice = createSlice({
  name: 'idemia',
  initialState,
  reducers: {
    saveUuid: (state, action) => {
      state.params.uuid = action.payload;
    },
    saveParams: (state, action) => {
      state.params = action.payload;
    },
    saveShorter: (state, action) => {
      state.shortUrl = action.payload;
    },
    initiate: (state, action) => {
      state.isInitiated = action.payload;
    },
    completeResult: (state) => {
      state.resultComplete = true;
    },
    showResults: (state) => {
      state.showResult = true;
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(connectWssBrowser.fulfilled, (state, action) => {
          state.isLoading = false;
        })
        .addCase(getIdemiaResults.fulfilled, (state, action) => {
          console.log(action.payload.results);
          state.results = action.payload.results;
        })
        .addMatcher(
            isAnyOf(
                connectWssBrowser.pending
            ),
            startLoading,
        )
        .addMatcher(
            isAnyOf(
                connectWssBrowser.rejected,
                getIdemiaResults.rejected
            ),
            handleError,
        )
  }
})

export const { reducer } = slice;
export const selectIdemia = (state) => state.idemia;
export const { saveUuid, saveParams, saveShorter, initiate, completeResult, showResults } = slice.actions;


export const connectWssBrowser = createAsyncThunk('@idemia/connectWssBrowser',
    async (_, { getState, dispatch }) => {
      const state = selectIdemia(getState());

      (await connect(state.params.uuid)).subscribe({
        next: (message) => {
          message = JSON.parse(message)
          if (message.code === 'INICIO') dispatch(initiate(true));
          else {
            dispatch(showResults());
            dispatch(getIdemiaResults(message.content));
          }

        },
        error: (err) => handleError(state, err),
      });
    }
)


export const shortUrlDesktop = createAsyncThunk('@idemia/shortUrlDesktop',
    async (url, { dispatch}) => {
      const shorter = await shortUrl(url);
      dispatch(saveShorter(shorter.data.result))
    })


export const connectWssMobile = createAsyncThunk('@idemia/connectWssMobile',
    async (params,  {getState, dispatch}) => {

      console.log('Conectandomeee enviando ws', params)

      const state = selectIdemia(getState());

      const decrypted = await decryptParams(params);
      decrypted['uuid'] = params['uuid'];

      console.log(decrypted);


      decrypted.seckey = 'MTZkODBkNzAtMzU1ZS00NThmLTk3MWQtNjc2ZGQ4Y2EzOWZi';


      const subject = webSocket({
        url: awsConfig.API.endpoints.find((endpoint) => endpoint.name === 'CallbackAPI').endpoint + `?room=${decrypted.uuid}`,
        openObserver: {
          next: (cd) => {
            console.log('Conectando', cd, decrypted)
            dispatch(saveParams(decrypted))
          },
        }
      });

      subject.subscribe();

      const message =  JSON.stringify({ "code": "INICIO", "content": "Holiiii!!" });
      subject.next({ action: 'sendmessage', message });
      subject.complete();
    }
)


export const connectWssMobileFinish = createAsyncThunk('@idemia/connectWssMobileFinish',
    async (params,  {getState, dispatch}) => {

      const state = selectIdemia(getState());


      const subject = webSocket({
        url: awsConfig.API.endpoints.find((endpoint) => endpoint.name === 'CallbackAPI').endpoint + `?room=${params.uuid}`,
        openObserver: {
          next: () => dispatch(completeResult()),
          error: (err) => handleError(state, err),
        }
      });


      subject.subscribe();

      const message =  JSON.stringify({ "code": "FIN", "content": params });

      subject.next({ action: 'sendmessage', message, uuid: params.uuid });
      subject.complete();
    }
)


export const getIdemiaResults = createAsyncThunk('@idemia/getIdemiaResults',
    async (params) => {

      const results = await fetchResults({
        idtx: params.idtx,
        apikey: "CO_CRTM_WB",
        seckey: "449a6a8a-55c2-43ad-a375-e87b4f719883"
      });

      return { results };
    }
)
